import React from "react";

export default function Alert({page, message}) {
  return (
    <div className="alert alert-info alert-icon">
      <i className={page == "cart" ? "fas fa-shopping-cart" : "fas fa-exclamation-circle"} /> {message}
    </div>
  );
}
